import Search from '../presentational/search';

export default Search;
